module.exports = __webpack_public_path__ + "img/header.299a1403.png";